import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSideList2Component } from './fi-side-list2/fi-side-list2.component';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiItemsListActionsComponent } from './fi-items-list-actions/fi-items-list-actions.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FiItemsListHelperService } from '@fi-shared/fi-items-list/fi-items-list-helper.service';
import { FiItemsListDisplayTypeComponent } from '@fi-shared/fi-items-list/fi-items-list-display-type/fi-items-list-display-type.component';
import { FiItemsListFilterModule } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.module';
import { FiItemsListSortSelectComponent } from './fi-items-list-sort-select/fi-items-list-sort-select.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        FiAppTextSharedModule,
        MatMenuModule,
        MatIconModule,
        FiItemsListFilterModule,
        MatDividerModule,
    ],
    declarations: [
        FiSideList2Component,
        FiItemsListActionsComponent,
        FiItemsListDisplayTypeComponent,
        FiItemsListSortSelectComponent,
    ],
    providers: [FiItemsListHelperService],
    exports: [
        FiSideList2Component,
        FiItemsListActionsComponent,
        FiItemsListDisplayTypeComponent,
        FiItemsListFilterModule,
        FiItemsListSortSelectComponent,
    ],
})
export class FiItemsListModule {}
